/* eslint-env browser, jquery */

'use strict';

require('../vendor/backbone');

const jsInitializer = require('../initializers/js_initializer');

const {
  critModules,
  nonCritModules,
  pageReadyModules,
} = require('./js_modules');

jsInitializer.addJsFiles(critModules, nonCritModules, pageReadyModules);
